import { fg } from '@atlaskit/platform-feature-flags';

function hasConfluenceUpgradeFreePoolTargetExperimentCohort() {
	// We don't have the AAID of the user, so we need to look through all the local storage keys
	// An example key would be: `localStorage/atlassian.762020:646a2652-9f79-4152-9368-d6e5g1dbf8a3.frontend.atl-UPFTConfluenceStandardOfferCohort`
	for (let i = 0; i < localStorage.length; i++) {
		const key = localStorage.key(i);
		if (
			key &&
			key.startsWith('localStorage/atlassian.') &&
			key.endsWith('.atl-UPFTConfluenceStandardOfferCohort') &&
			localStorage.getItem(key) !== 'not-enrolled'
		) {
			return true;
		}
	}
	return false;
}

export function isEnrolledInConfluenceUpgradeFreePoolTargetExperiment(): boolean {
	if (!fg('twcg-206_confluence_upgrade_permanent_free_fg')) {
		return false;
	}
	return hasConfluenceUpgradeFreePoolTargetExperimentCohort();
}
